import { render } from "./BaugrundstueckStep3.vue?vue&type=template&id=9e9944d4&scoped=true"
import script from "./BaugrundstueckStep3.vue?vue&type=script&lang=js"
export * from "./BaugrundstueckStep3.vue?vue&type=script&lang=js"

import "./BaugrundstueckStep3.vue?vue&type=style&index=0&id=9e9944d4&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e9944d4"]])

export default __exports__